(function () {
  var MOBILE_QUERY = '(max-width: 1200px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function syncMainHeight(panel) {
    if (!panel) return;

    var main = panel.querySelector('.archive-tabs-99__main'); // event-tabs-99__main in the event file
    var img = panel.querySelector('[data-main-image]');
    if (!main || !img) return;

    if (!isMobile()) {
      main.style.height = '';
      return;
    }

    function apply() {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var width = main.getBoundingClientRect().width;
      var ratio = img.naturalHeight / img.naturalWidth;
      main.style.height = Math.round(width * ratio) + 'px';
    }

    if (img.complete && img.naturalWidth) {
      apply();
    } else {
      img.addEventListener('load', apply, { once: true });
    }
  }

  function initArchiveTabs(root) {
    var seasonToggles = root.querySelectorAll('[data-season-toggle]');
    var seasonItems = root.querySelectorAll('.archive-tabs-99__season');
    var allTabs = root.querySelectorAll('.archive-tabs-99__tab');
    var allPanels = root.querySelectorAll('.archive-tabs-99__panel');

    function getActivePanel() {
      var active = null;
      allPanels.forEach(function (panel) {
        if (panel.classList.contains('is-active')) active = panel;
      });
      return active;
    }

    seasonToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        activateSeason(toggle.getAttribute('data-season-toggle'));
      });
    });

    function activateSeason(seasonIndex) {
      seasonItems.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-season-index') === seasonIndex);
      });

      var activeSeason = root.querySelector('.archive-tabs-99__season[data-season-index="' + seasonIndex + '"]');
      if (activeSeason) {
        var firstPostIndex = activeSeason.getAttribute('data-first-post');
        activatePost(firstPostIndex);
      }
    }

    function activatePost(postIndex) {
      allTabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-post-index') === postIndex);
      });

      allPanels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-post-panel') === postIndex;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });

      syncMainHeight(getActivePanel());
    }

    allTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activatePost(tab.getAttribute('data-post-index'));
      });
    });

    allPanels.forEach(function (panel) {
      var mainImage = panel.querySelector('[data-main-image]');
      var thumbs = panel.querySelectorAll('.archive-tabs-99__thumb');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (mainImage) {
            mainImage.src = thumb.getAttribute('data-thumb-src');
            syncMainHeight(panel);
          }
          thumbs.forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    });

    syncMainHeight(getActivePanel());

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        syncMainHeight(getActivePanel());
      }, 150);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.archive-tabs-99').forEach(initArchiveTabs);
  });
})();